export const SEARCH_STRING = "SEARCH_STRING";
export const SELECTED_CATEGORY = "SELECTED_CATEGORY";
export const TOGGLE_SELECTED_COMPANY = "TOGGLE_SELECTED_COMPANY";
export const CLEAR_SELECTED_COMPANIES = "CLEAR_SELECTED_COMPANIES";
export const SAVE_SCROLL_POSITION = "SAVE_SCROLL_POSITION";
export const REMOVE_SCROLL_POSITION = "REMOVE_SCROLL_POSITION";
export const CONTENT_EMBEDDED = "CONTENT_EMBEDDED";
